import { useCallback, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../generic/Button';
import { icons } from '../generic/Icon';
import { Revision, RevisionLicense } from '../../types';
import EditableList from './EditableList';

type ModalEditGroupsProps = {
  onCancel: () => void;
  onSave: (groups: Array<Array<Partial<RevisionLicense>>>) => void;
  show: boolean;
  revision: Revision;
}

const ModalEditGroups = ({ onCancel, onSave, revision, show }: ModalEditGroupsProps) => {
  const [groups, setGroups] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const handleGroupsChange = useCallback((newGroups) => {
    setIsDirty(true);
    setGroups(newGroups.map(({ licenses }) => licenses));
  }, []);
  const handleSave = useCallback(() => {
    onSave(groups);
    setIsDirty(false);
  }, [groups, onSave]);
  return (
    <Modal show={show} backdrop animation onHide={onCancel} className="modal-edit-dependency">
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Licenses
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-fossa">
          <EditableList revision={revision} onChange={handleGroupsChange} canEdit />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <span className="margin-right-sm">
          <Button
            type="secondary"
            size="medium"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </span>
        <Button
          type="primary"
          size="medium"
          icon={icons.save}
          onClick={handleSave}
          isDisabled={!isDirty}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEditGroups;
